import React from 'react';
import { PqrWebService } from '../../services/services';

export interface IDescargaComponentState {
  downloadLink: string;
}
export class DescargaComponent extends React.Component<any,IDescargaComponentState> {

  private _pqrWebService: PqrWebService; 

  constructor(props: any) {
    super(props);

    this._pqrWebService = new PqrWebService();
  }

  public async componentDidMount(): Promise<void> {
    try {
      
      const search = window.location.hash.split('?');
      const queryParams = new URLSearchParams(search[ 1 ]);

      if (queryParams !== undefined) {

        var result = await this._pqrWebService.decryptsAsync(search[ 1 ].replace("codigo=", ""));
        var campos = result.Nombre.split('-');
       
        var file = await this._pqrWebService.getDocumentSedeAsAnonymousAsync(parseInt(campos[ 0 ]), campos[ 1 ]);

        console.log("file",file);
      }
    } catch (err) {
      if (err instanceof Error) {
        alert(err.message);
      }
    }
  }

  render(): JSX.Element {
    return <div className='ms-Grid'>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-12' style={{ marginTop: '15px',alignContent:'center' }}>
          <h1 className='ms-font-xl ms-fontWeight-semibold'></h1>
          <div style={{alignContent:'center'}}>
            La descarga puede tardar varios minutos dependiendo del tamaño del documento y la velocidad de tu internet.
          </div>
        </div>
      </div>

    </div>
  }

}